<section>
  <div class="licence-agreement-page">
    <div class="licence-agreement-section">
      <img
        src="../../../assets/img/Power-x.svg"
        alt="powerx-logo"
        class="header-powerx-logo"
      />
      <div class="user-agreement">
        <div class="m-b-16">
          <span class="main-agreement-heading">Rockwell Trading Software License Agreement</span>
        </div>
        <h4 class="agreement-info">This is legal agreement between you and Rockwell Trading</h4>

        <app-license-agreement-text></app-license-agreement-text>

        <div class="agreement-checkbox">
          <mat-checkbox
            [(ngModel)]="dataConsentCheckbox"
            color="primary"
            class="example-margin"
          >
            I acknowledge that my anonymized financial data may be used for benchmarking and analytics. I have read and
            agree to the
            <a
              (click)="$event.stopPropagation()"
              href="https://www.rockwelltrading.com/privacy-policy/"
              target="_blank"
              rel="noopener noreferrer"
              class="agreement-link"
              >Privacy Policy</a
            >
            and
            <a
              (click)="$event.stopPropagation()"
              href="https://www.rockwelltrading.com/terms-of-use/"
              target="_blank"
              rel="noopener noreferrer"
              class="agreement-link"
              >Terms of Use</a
            >.
          </mat-checkbox>
          <mat-checkbox
            [(ngModel)]="agreementCheckbox"
            color="primary"
            class="example-margin"
            >I have read and agreed to be bound by Agreement above. I also confirm that I am of legal age of majority in
            the jurisdiction in which I reside (at least 18 years of age in many countries).
          </mat-checkbox>
        </div>
      </div>
      <div class="agreement-action-btns">
        <button
          [disabled]="!(agreementCheckbox && dataConsentCheckbox)"
          (click)="licenceAgreed()"
          mat-flat-button
          color="primary"
          class="i-agree-btn"
        >
          @if (isLoading) {
            <mat-spinner
              class="white-spinner"
              diameter="20"
            ></mat-spinner>
          }
          @if (!isLoading) {
            <span>I Agree</span>
          }
        </button>
        <button
          (click)="licenceclosed()"
          mat-stroked-button
          class="cancel-btn"
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
</section>
